import http from "./httpService";

const apiEndPoint = "/relevances/";

function getRelevances() {
  return http.get(apiEndPoint);
}

export default getRelevances;
